import Image from "next/image";
import styled from "styled-components";
import { Slide as UISlide } from "@chakra-ui/react";
import { MobileView } from "./components/HeaderProfile/styles";
import { NavSidebarProps } from "components";

export const Root = styled.div`
  position: relative;
`;

export const Slide = styled(UISlide)<{ in: boolean }>`
  z-index: 1000 !important;
  top: var(--header-height) !important;

  @media (max-width: 500px) {
    top: var(--mobile-header-height) !important;
  }

  @media (min-width: 1540px) {
    display: none;
  }

  ${({ in: isOpen }) => (isOpen ? "" : "display: none;")}
`;

export const Header = styled.div<{ fixed: boolean }>`
  ${({ fixed }) => (fixed ? "position: fixed;" : "position: relative;")}
  display: flex;
  z-index: 1002;
  width: 100%;
  height: var(--header-height);
  left: 0;
  background-color: var(--global-bg-dark-2);
  padding: 12px 24px;
  gap: 1px;

  &::after {
    content: "";

    @media (max-width: 500px) {
      position: absolute;
      top: 50%;
      left: 0;
      display: block;
      width: 100%;
      height: 1px;
      background: #151c2c;
    }
  }

  @media (max-width: 500px) {
    flex-direction: column;
    height: var(--mobile-header-height);
  }

  @media (max-width: 767px) {
    padding: 12px 6px 8px 8px;
  }

  // toggle
  & input[data-toggle] {
    display: none;
  }
  & input[data-toggle]:checked + label[data-button-container] > div[data-button]::before {
    margin-top: 0px;
    transform: rotate(405deg);
  }
  & input[data-toggle]:checked + label[data-button-container] > div[data-button] {
    background: transparent;
  }
  & input[data-toggle]:checked + label[data-button-container] > div[data-button]::after {
    margin-top: 0px;
    transform: rotate(-405deg);
  }
  & label[data-button-container] {
    position: relative;
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 40px;
    width: 40px;
    padding: 8px;
    cursor: pointer;
  }
  & div[data-button],
  & div[data-button]::after,
  & div[data-button]::before {
    display: block;
    position: absolute;
    height: 3.84px;
    width: 24px;
    border-radius: 2px;
    transition: transform 400ms cubic-bezier(1, 0, 0, 1); // cubic-bezier(0.23, 1, 0.32, 1)
    background-color: rgba(210, 234, 255, 0.75);
  }
  & div[data-button]::before {
    content: "";
    margin-top: calc(-2 * 3.84px);
  }
  & div[data-button]::after {
    content: "";
    margin-top: calc(2 * 3.84px);
  }
  @media (max-width: 1540px) {
    & label[data-button-container] {
      display: flex;
    }
    & input[data-toggle] ~ ul[data-list] {
      background-color: transparent;
      height: 0;
      min-height: unset;
      transition-delay: 0;
      transition-duration: 400ms, 400ms, 400ms;
      transition-property: background-color, height, min-height;
      transition-timing-function: cubic-bezier(0.5, 0, 0.5, 1), cubic-bezier(0.5, 0, 0.5, 1),
        step-start; // cubic-bezier(0.42, 0, 0.58, 1), cubic-bezier(0.23, 1, 0.32, 1), step-end;
    }
    & input[data-toggle]:checked ~ label[data-button-container] {
      // background: rgba(35, 163, 255, 0.05);
      border-radius: 8px;
    }
    /* & input[data-toggle]:checked ~ label[data-button-container] > div[data-button], */
    & input[data-toggle]:checked ~ label[data-button-container] > div[data-button]::after,
    & input[data-toggle]:checked ~ label[data-button-container] > div[data-button]::before {
      background-color: #3b8be9;
    }
    & input[data-toggle]:checked ~ ul[data-list] {
      background-color: var(--top-menu-bg-burger);
      height: calc(100% - var(--top-menu-nav-height));
      min-height: calc(100vh - var(--top-menu-nav-height));
      transition-timing-function: cubic-bezier(0.5, 0, 0.5, 1), cubic-bezier(0.5, 0, 0.5, 1),
        step-end;
    }
  }
`;

export const Nav = styled.aside<NavSidebarProps>`
  display: flex;
  flex-direction: column;
  padding: 16px;
  height: calc(100% - (var(--header-height) + 1px));
  top: calc(var(--header-height) + 1px);
  overflow-y: auto;
  background-color: var(--global-bg-dark-1);
  border-top: 1px solid var(--global-bg-dark);
  position: fixed;
  min-width: var(--sidebar-width);
  left: 0;
  z-index: 17;
  transform: ${({ show }) => (show ? "translateX(0)" : "translateX(-100%)")};

  @media (max-width: 500px) {
    top: calc(var(--mobile-header-height) + 1px);
    transform: translateX(-100%);
  }

  @media (max-width: 1400px) {
    left: 0;
    width: var(--sidebar-width);
    transition: transform 0.4s;

    height: calc(100vh - var(--header-height));
  }
`;

export const DropNav = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  margin-bottom: auto;
`;

export const Logo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  z-index: 1;
`;

export const AdaptiveLogo = styled(Image)`
  width: 186px;
  max-width: 186px;
  height: 36px;

  @media (max-width: 1024px) {
    max-width: 58px;
    width: 58px;
  }
`;

export const Profile = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;

  @media (max-width: 1540px) {
    ${MobileView} {
      display: none;
    }
  }
`;

export const MobileMenuItem = styled.div<{ isActive: boolean }>`
  min-width: 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end;
  color: var(--clouds-100);
  font-family: var(--font-family-golos);
  font-size: 10px;
  padding: 8px;
  gap: 4px;
  flex-shrink: 0;
  border-radius: 6px;
  cursor: pointer;
  text-transform: capitalize;
  ${({ isActive }) =>
    isActive &&
    `
    background: rgba(0, 178, 255, 0.05);
    color: var(--pure-sky);
  `}
`;

export const DropDownBack = styled.div`
  display: flex;
  flex-direction: column;
  background: #131620;
  width: 100vw;
  height: calc(100vh - var(--header-height));
  padding: 16px 16px;
  overflow: scroll;

  @media (max-width: 500px) {
    height: calc(100vh - var(--mobile-header-height));
  }
`;

const ProfileButton = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px 32px;
  width: 100%;
  border: 0;
  border-radius: 8px;

  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 16.8px;
  letter-spacing: 0.01em;

  &:hover {
    opacity: 0.8;
  }

  &:active {
    opacity: 0.7;
  }
`;

export const LogoutButton = styled(ProfileButton)`
  background: #c842300d;
  color: #c84230;
`;

export const SignInButton = styled(ProfileButton)`
  background: #51cb490d;
  color: #51cb49;
`;

export const MobileHeaderBlock = styled.div`
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 2px solid #e9f4ff0d;
`;

export const TopHeaderMenu = styled.div`
  flex: 1 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  height: 100%;

  @media (max-width: 1540px) {
    justify-content: center;
  }
`;

export const MobileMenu = styled.div`
  flex: 1 0;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 8px;
  width: 100%;
  height: 100%;
  padding-top: 8px;

  @media (min-width: 501px) {
    display: none;
  }
`;

export const MobileItems = styled.div`
  flex-grow: 1;
`;

export const AuthBlock = styled.div`
  margin-top: auto;
`;

export const MobileMenuItemIcon = styled.div`
  cursor: pointer;
  svg {
    width: 24px;
    height: 24px;
  }
`;
